import { render, staticRenderFns } from "./alarmTable.vue?vue&type=template&id=456f4616&scoped=true&"
import script from "./alarmTable.vue?vue&type=script&lang=js&"
export * from "./alarmTable.vue?vue&type=script&lang=js&"
import style0 from "./alarmTable.vue?vue&type=style&index=0&id=456f4616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456f4616",
  null
  
)

export default component.exports